"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// prettier-ignore
exports.default = {
    "hasMoneysoftAccess": true,
    "hasAccount": true,
    "financialAccountDetails": [
        {
            "accountStatus": 1,
            "assetCategory": 1,
            "assetCategoryOverride": 0,
            "assetType": 1,
            "assetTypeOverride": 0,
            "balanceSign": 0,
            "currentBalance": 100,
            "asAtBalance": 0,
            "asAtBalanceSign": 0,
            "asAtDateUtc": "2022-12-21T23:16:21.062Z",
            "name": "Some Name"
        }
    ]
};
